import { AxiosError, AxiosResponse } from 'axios'
import { handleException } from 'src/Helpers/ResponseHelpers'
import { ICreateUserScheduleBonusRequest } from 'src/Models/Server/Request/UserScheduleBonus/ICreateUserScheduleBonusRequest'
import { IEditUserScheduleBonusRequest } from 'src/Models/Server/Request/UserScheduleBonus/IEditUserScheduleBonusRequest'
import { IExceptionError } from 'src/Models/Server/Response/Exception/ExceptionError'
import { IUserScheduleBonusSTO } from 'src/Models/Server/Response/IUserScheduleBonusSTO'
import { axiosAuth } from '../AuthAxios'

export default {
  Insert(request: ICreateUserScheduleBonusRequest) {
    return new Promise<void>(
      (resolve, reject: (error: IExceptionError) => void) => {
        axiosAuth
          .post(`/api/v1/userschedulebonus/insert`, request)
          .then(() => {
            resolve()
          })
          .catch((error: AxiosError) => {
            handleException(error, reject)
          })
      }
    )
  },
  Edit(request: IEditUserScheduleBonusRequest) {
    return new Promise<void>(
      (resolve, reject: (error: IExceptionError) => void) => {
        axiosAuth
          .post(`/api/v1/userschedulebonus/edit`, request)
          .then(() => {
            resolve()
          })
          .catch((error: AxiosError) => {
            handleException(error, reject)
          })
      }
    )
  },
  GetUserScheduleBonuses(userGuid: string) {
    return new Promise<IUserScheduleBonusSTO[]>(
      (resolve, reject: (error: IExceptionError) => void) => {
        axiosAuth
          .get(`/api/v1/userschedulebonuses/${userGuid}`)
          .then((response: AxiosResponse<IUserScheduleBonusSTO[]>) => {
            resolve(response.data)
          })
          .catch((error: AxiosError) => {
            handleException(error, reject)
          })
      }
    )
  },
  GetUserScheduleBonus(userScheduleBonusId: string) {
    return new Promise<IUserScheduleBonusSTO>(
      (resolve, reject: (error: IExceptionError) => void) => {
        axiosAuth
          .get(`/api/v1/userschedulebonus/${userScheduleBonusId}`)
          .then((response: AxiosResponse<IUserScheduleBonusSTO>) => {
            resolve(response.data)
          })
          .catch((error: AxiosError) => {
            handleException(error, reject)
          })
      }
    )
  },
  TurnOff(userSchedulerId: number) {
    return new Promise<void>(
      (resolve, reject: (error: IExceptionError) => void) => {
        axiosAuth
          .post(`/api/v1/userschedulebonus/turnoff/${userSchedulerId}`, null)
          .then(() => {
            resolve()
          })
          .catch((error: AxiosError) => {
            handleException(error, reject)
          })
      }
    )
  },
}
